<template>
  <div class="gameplay-hints">
    <p class="text3">Hints</p>
    <SiestaHint
      @showHint="showHint"
      v-for="index in 3"
      :key="index"
      :index="index"
    />
  </div>
</template>

<script>
import SiestaHint from "./SiestaHint";

export default {
  components: { SiestaHint },
  methods: {
    showHint() {
      this.$emit("showHint");
    },
  },
};
</script>

<style lang="scss" scoped>
.gameplay-hints {
  user-select: none;
  flex: 1;
}
.text3 {
  text-align: center;
  margin-bottom: rems(6px);
}
</style>
